import React from "react";
import PropTypes from "prop-types";

import "../../../styles/RadioSwitchButton.scss";

/**
 * A button for moving items up or down
 * @name RadioSwitchButton
 * @param {boolean} disabled
 * @param {string} leftLabel
 * @param {string} leftValue
 * @param {string} id
 * @param {string} name
 * @param {function} onChange
 * @param {string} rightLabel
 * @param {string} rightValue
 * @param {string} selectedValue
 * @return {JSX.Element}
 * @constructor
 */
const RadioSwitchButton = ({
    disabled,
    leftLabel,
    leftValue,
    id,
    name,
    onChange,
    rightLabel,
    rightValue,
    selectedValue
}) => (
    <div className="switch-container" role="radiogroup">
        <label className={`switch-label ${selectedValue === leftValue ? "selected" : ""}`} htmlFor={`left-side-${id}`}>
            <input
                checked={selectedValue === leftValue}
                disabled={disabled}
                id={`left-side-${id}`}
                name={name}
                onChange={onChange}
                type="radio"
                value={leftValue}
                aria-checked={selectedValue === leftValue}
            />
            <span className="option left">{leftLabel}</span>
        </label>
        <label
            className={`switch-label ${selectedValue === rightValue ? "selected" : ""}`}
            htmlFor={`right-side-${id}`}
        >
            <input
                checked={selectedValue === rightValue}
                disabled={disabled}
                id={`right-side-${id}`}
                name={name}
                onChange={onChange}
                type="radio"
                value={rightValue}
                aria-checked={selectedValue === rightValue}
            />
            <span className="option right">{rightLabel}</span>
        </label>
    </div>
);

RadioSwitchButton.propTypes = {
    disabled: PropTypes.bool,
    leftLabel: PropTypes.string.isRequired,
    leftValue: PropTypes.string.isRequired,
    id: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func.isRequired,
    rightLabel: PropTypes.string.isRequired,
    rightValue: PropTypes.string.isRequired,
    selectedValue: PropTypes.string.isRequired
};

RadioSwitchButton.defaultProps = {
    disabled: false
};

export default RadioSwitchButton;
